﻿export class SurveyDetails {
    id: number;
    code: string;
    validFrom: Date;
    validTo: string;
    surveyTypeId: number;
    surveyCategoryId: number;
    totalQuestions: number;
    surveyParticipantTypeId: number;
    surveyStatusId: number;
    dateCreated: Date;
    smsverificationRequired: boolean;
    masterSurvey: boolean;
    surveyUniqueIdentifier: string;
    masterSurveyId: number;

}